import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import SHORTCUTS from 'constants/keyboardShortcuts';
import Shortcut from './components/Shortcut';

import { StyledModalBody, StyledModalHeader, StyledShortcuts } from './styled';

/* eslint-disable react/no-array-index-key */
const ShortcutsModal = ({ isOpen, onCloseRequest }) => (
  <Modal
    closeOnEsc
    isLarge
    isOpen={isOpen}
    maxWidth={900}
    onCloseRequest={onCloseRequest}
  >
    <StyledModalHeader
      icon={<span className="icon-keyboard" />}
      title="NLU Keyboard Shortcuts"
    />
    <StyledModalBody>
      <StyledShortcuts>
        {SHORTCUTS.map((shortcut, index) => (
          <Shortcut key={index} shortcut={shortcut} />
        ))}
      </StyledShortcuts>
    </StyledModalBody>
  </Modal>
);

ShortcutsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseRequest: PropTypes.func.isRequired,
};

export default ShortcutsModal;
